export default "__VITE_ASSET__ncZ2ILpO__"